export default __webpack_public_path__ + "static/media/icon-non-harmony.7484f41b.svg";